export default function trackGtmEvent(gtm, eventName, payload = {}) {
  const dataLayer = typeof gtm?.dataLayer === 'function' ? gtm.dataLayer() : null;

  if (!Array.isArray(dataLayer)) return;

  dataLayer.push({ event: eventName, ...payload });
}
